const initialState = {
  list: [],
  loading: 'idle',

  total: 0,
  count: {},
};

export default initialState;
